import { apiAxios } from "./axios";

class FeedbackService {
  async getComments(matchId: string) {
    try {
      const response = await apiAxios.get(`/feedback/${matchId}`);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching comments:", error);
      return [];
    }
  }

  async createFeedback(data: {
    matchId: string;
    feedback?: string;
    rating?: any;
    offerUrl?: string;
  }) {
    try {
      const response = await apiAxios.post("/feedback", data);
      return response.data;
    } catch (error) {
      console.error("Error creating feedback:", error);
      throw error;
    }
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;